import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from 'components/Dialog'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import { Heading } from 'components/Heading'
import { Stack } from 'components/Stack'
import styles from './RegionDialog.module.scss'
import { RegionFormParams } from 'models/region'
import { RegionForm } from 'features/shared/RegionForm'
import { Flex } from 'components/Flex'

type RegionDialogProps = {
  status?: string
  onClose: () => void
  onConfirm: (data: RegionFormParams) => void
}

export const RegionDialog: FC<RegionDialogProps> = ({ onClose, onConfirm, status = 'idle' }) => {
  const { t } = useTranslation()

  return (
    <Dialog
      aria-label={t('create_project.region_dialog.title')}
      isOpen={true}
      onClose={onClose}
      className={styles.regionDialog}
    >
      <Stack>
        <Stack space="xsmall" component="header">
          <Flex justify="start" align="center">
            <div className={styles.icon}>
              <Icon name="globe-line" />
            </div>
            <Heading size="secondary">{t('create_project.region_dialog.title')}</Heading>
          </Flex>
          <Text>{t('create_project.region_dialog.desc')}</Text>
        </Stack>

        <RegionForm status={status} submitArea={onConfirm} />
      </Stack>
    </Dialog>
  )
}

RegionDialog.displayName = 'RegionDialog'
